import FocusBearLogoAnimated from 'assets/icons/FocusBearLogoAnimated';
import { ATTRIB } from 'constants/test';
import { t } from 'services/i18n.service';

interface Props {
  readonly title?: string;
  icon?: JSX.Element;
}

function Loading({
  icon = <FocusBearLogoAnimated className='~w-24/40 ~h-24/40' />,
  title
}: Props) {
  return (
    <section
      data-testid={ATTRIB.DATA_TESTID.LOADING_SCREEN}
      className='w-full h-full flex flex-col justify-center items-center ~gap-5/20 animate-fadeIn bg-secondary-50 dark:bg-secondary-dark-200 dark:text-secondary-dark-900 text-primary-900 ~p-4/10'>
      {icon}
      <h1 className='w-fit h-fit animate-pulse text-center ~py-2/4 text-inherit'>
        {title ?? t('lazy_load_placeholder.focus_bear_is_waking_up')}
      </h1>
    </section>
  );
}

export default Loading;
